




















import Vue from 'vue';
// import { mapState } from 'vuex';
import {Conversation} from '../store-types';


export default Vue.extend({ // <{active: string}, >({
  data() {
    return {
      active: null
    };
  },
  computed: {
    tabs() {
      const tabs = [];
      // tslint:disable forin
      for (const id in this.$store.state.openConversations) {
        const conv: Conversation = this.$store.state.conversations[id];
        const route = `/chat/${conv.botId}/${id}`;
        const label = conv.name || id;  // this.store.state.bots[conv.botId].name
        tabs.push({
          id,
          label,
          route,
          messageCount: conv.messageCount
        });
      }
      return tabs;
    }
  },
  watch: {
    $route: 'onRoute'
  },
  created() {
    this.onRoute();
  },
  methods: {
    onRoute() {
      /*this.$store.dispatch('selectConversation', {
          botId: this.$route.params.botId,
          convId: this.$route.params.conversationId
      });*/
      this.$store.commit('selectConversation', {
          botId: this.$route.params.botId,
          convId: this.$route.params.conversationId
      });

      if (!this.$route.params.conversationId) {
        if (this.tabs.length) {
          this.$router.replace({path: this.tabs[0].route});
        } else {
          this.active = null;
        }
      }
    }
  }
});

/*
import { Component, Vue } from 'vue-property-decorator';

@Component({
  watch: {
    $route: 'onRoute'
  }
})
export default class ChatToolbar extends Vue {
  active: string = null;

  created() {
    this.onRoute();
  }

  onRoute() {
    this.$store.commit('selectConversation', this.$route.params['conversationId']);
  }

  get tabs() {
    return this.$store.state.openConversationIds.map(id => {
      const conv: Conversation = this.$store.state.conversations[id];
      const route = `/chat/${conv.botId}/${conv.id}`;
      const label = conv.name || conv.id;  // this.store.state.bots[conv.botId].name
      return {
        id,
        label,
        route,
        messageCount: conv.messageCount
      };
    });
  }
}*/
